import {selectDialog} from "@redux/selectors/dialog";
import {connect} from "react-redux";
import {IDialog, update as updateDialog} from "@redux/slices/dialog";
import {Update} from "@redux/slices/base";
import {Dialog} from "@components/interface/Dialog";
import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import React, {CSSProperties, useContext} from "react";
import {THEME} from "@components/core/theme";
import {Localisation} from "@components/localisation/localisation";
import {HostContext} from "@components/host/HostProvider";
import {Game} from "@game/game";

const PATREON_AUTHENTICATE="https://www.patreon.com/oauth2/authorize";
const PATREON_CLIENT_ID="lshrGe4D35LSzOEmInVWC7Wz23XF7pvxVSiZ43MYWpEuISwyU92gPmCpq7PhaccS";
const PATREON_REDIRECT = "https://server.wordland.uk/authenticate/patreon";
const PATREON_URL="https://patreon.com/Wordland";

const styles: Record<string, CSSProperties> = {
    ...THEME,
    bottomBar: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: 8
    },
    button: {
        fontSize: "large",
        margin: 2,
        padding: 4
    },
    paragraph: {
        margin: 4
    },
    paragraphCentered: {
        display: "flex",
        justifyContent: "center",
        margin: 8
    }
}
interface IRemoveAdverts {
    dialog: IDialog
    game: Game
    updateDialog: Update
}

function RemoveAdverts({dialog, game, updateDialog}: IRemoveAdverts) {
    const host = useContext(HostContext);
    const handleLinkAccountClick = () => {
        const state= game.userPlayer?.playerId;

        window.location.href = [
            `${PATREON_AUTHENTICATE}?client_id=${PATREON_CLIENT_ID}`,
            "scope=identity%20identity.memberships",
            "allow_signup=true",
            "response_type=code",
            `state=${state}`,
            `redirect_uri=${PATREON_REDIRECT}`
        ].join("&");
    }

    if (dialog.name !== "removeAdverts") return null;
    return (
        <Dialog close={true} title="RemoveAdvertsTitle">
            <div style={styles.paragraph}>
                <LocalisedTypography content="RemoveAdvertsContent1"/>
            </div>
            <div style={styles.paragraph}>
                <LocalisedTypography content="RemoveAdvertsContent2"/>
            </div>
            <div style={styles.paragraphCentered}>
                <a target="patreon" title={Localisation.GetText("RemoveAdvertsLink")} href={PATREON_URL}
                   style={styles.text}>
                    <LocalisedTypography content="RemoveAdvertsLink"/>
                </a>
            </div>
            <div style={styles.paragraphCentered}>
                <button onClick={handleLinkAccountClick} style={styles.button}>
                    <LocalisedTypography content="ButtonLinkPatreonAccount"/>
                </button>
            </div>
    </Dialog>
)
    ;
}

const mapStateToProps = (store: never) => ({
    dialog: selectDialog(store)
});
const connected = connect(mapStateToProps, {
    updateDialog
})(RemoveAdverts);
export {connected as RemoveAdverts}
